import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Snippet from '../Snippet';
import '../../../case/docket/Docket.less';
import ClaimsEntry from '../../../case/claims/claimsEntries/ClaimsEntry';
import * as docketActions from '../../../../redux/actions/docketActions';
import * as claimDocumentsActions from '../../../../redux/actions/claimDocumentsActions';

const ClaimsResultRow = ({ row, id, getDocuments, selectedDocket, getClaimsDocuments, selectedClaim }) => {
  const onGetDocketDocuments = (docket, court_code, case_number) => {
    getDocuments({
      docket_no: docket.docket_no,
      docket_seq: docket.docket_seq,
      court_code,
      case_number,
    });
  };

  const onGetClaimsDocuments = (claimNum, seqNum, court_code, case_number) => {
    getClaimsDocuments({
      claimNum,
      seqNum,
      court_code,
      case_number,
    });
  };

  return (
    <Fragment>
      <table>
        <tbody>
          <ClaimsEntry
            id={id}
            claim={row}
            selectedDocket={selectedDocket}
            onGetDocuments={onGetDocketDocuments}
            selectedClaim={selectedClaim}
            onGetClaimsDocuments={onGetClaimsDocuments}
          />
        </tbody>
      </table>
      {row.parts && Object.values(row.parts).map((part, idx) => <Snippet key={idx} part={part} />)}
    </Fragment>
  );
};

ClaimsResultRow.propTypes = {
  row: PropTypes.any.isRequired,
  id: PropTypes.number.isRequired,
  selectedDocket: PropTypes.any.isRequired,
  getDocuments: PropTypes.func.isRequired,
  selectedClaim: PropTypes.any.isRequired,
  getClaimsDocuments: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  selectedDocket: state.getIn(['dockets', 'selectedDocket']).toJS(),
  selectedClaim: state.getIn(['claimDocuments', 'selectedClaim']).toJS(),
});

const mapDispatchToProps = {
  getDocuments: docketActions.getDocuments,
  getClaimsDocuments: claimDocumentsActions.getDocuments,
};

export default connect(mapStateToProps, mapDispatchToProps)(ClaimsResultRow);



// WEBPACK FOOTER //
// ./src/components/advancedSearch/results/rows/ClaimsResultRow.jsx